var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsInt, IsNotEmpty, Min } from 'class-validator';
/**
 * One rrweb batch. `events` is forwarded as-is to S3 as JSON — the backend
 * never interprets the rrweb format. `seq` is a monotonic, frontend-assigned
 * counter so the review endpoint can concatenate batches in capture order
 * even if HTTP/sendBeacon delivery reorders them.
 *
 * rrweb events are deliberately typed as `unknown[]` here so the recorder
 * can evolve without dragging shared DTO churn behind it.
 */
export class IngestReplayBatchDto {
    seq;
    events;
}
__decorate([
    IsInt(),
    Min(0),
    __metadata("design:type", Number)
], IngestReplayBatchDto.prototype, "seq", void 0);
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], IngestReplayBatchDto.prototype, "events", void 0);
//# sourceMappingURL=ingest-replay-batch.dto.js.map